<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="已绑定">
                <Bind />
            </el-tab-pane>
            <el-tab-pane label="未绑定">
                <Normal />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import Bind from './component/Bind'
import Normal from "./component/Normal";
export default {
    name: 'LayoutDemo',
    components: {
        Normal,
        Bind
    }
}
</script>